/**
 * PropertyItem
 * 
 * @Author: Focci
 * @Date: 2024-11-07 09:12:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-07 09:12:22
 */

// import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { useMapState } from '@comp/mapbox'
import { useCallback } from 'react'
import OverallItemScoff, { OverallItemSwitch } from '../OverallItemScoff'

export default function PropertyItem({ options }) {
  const ts = useTranslations('search')
  const mapboxState = useMapState()

  const handleChange = useCallback((e, { value }) => {
    mapboxState.valueSetter(value, e.target.checked)
  }, [mapboxState])
  
  return (
    <OverallItemScoff title={ts('displayProperty')} expanding>
      <div className="grid grid-cols-1 gap-2">
        {options.map((item) => (
          <OverallItemSwitch 
            key={item.value} 
            label={item.label} 
            checked={mapboxState[item.value]}
            onChange={(e) => handleChange(e, item)}
          />
        ))}
      </div>
    </OverallItemScoff>
  )
}

// PropertyItem.propTypes = {
//   className: PropTypes.string,
// }
